import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
// import CryptoJS from "crypto-js";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
const secretKey = process.env.REACT_APP_SECRET_KEY || "default-fallback-key";
const API_URL = process.env.REACT_APP_API_URL;
const API_FILE = process.env.REACT_APP_FILE_URL;
const URL = process.env.PUBLIC_URL;

type Detail = {
    id: number;
    note: string | null;
    files?: string[];
    user_check: 0 | 1;
    admin_check?: 0 | 1;
};

type Drawing = {
    id: number;
    note: string | null;
    coordinates: any[];
    details: Detail[];
    // files?: string | null;
};

type SlideBarProps = {
    drawings: Drawing[];
    loading: boolean;
    reload: () => void;
    setScrollIndex: React.Dispatch<React.SetStateAction<number | null>>;
};


export default function SlideBar({ drawings, loading, reload, setScrollIndex }: SlideBarProps) {
    // const [filesMap, setFilesMap] = useState<{ [key: number]: File[] }>({});
    // const [data, setData] = useState<any>(null);
    // const [loading, setLoading] = useState(true);
    // const [filter, setFilter] = useState(null);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [collapse, setCollapsed] = useState(false);
    const [filter, setFilter] = useState<"done" | "notdone" | null>(null);
    const location = useLocation();
    const isDetailPage = /^\/detail\/[^/]+$/.test(location.pathname);
    const { id } = useParams();
    const allDetails = drawings?.flatMap(drawing => drawing.details) || [];
    // let id = "";

    // if (id) {
    //     try {
    //         const bytes = CryptoJS.AES.decrypt(decodeURIComponent(id), secretKey);
    //         id = bytes.toString(CryptoJS.enc.Utf8);
    //     } catch (e) {
    //         console.error("Decrypt error:", e);
    //     }
    // }

    const filteredDetails = allDetails.filter(item => {
        if (filter === "done") return item.user_check === 1;
        if (filter === "notdone") return item.user_check === 0 || item.user_check === null;
        return true;
    });

    const handleUserClick = async (id: number) => {
        try {
            const resUser = await fetch(`${API_URL}/detail-user-check/${id}`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                },
            });

            if (!resUser.ok) {
                throw new Error(`Error ${resUser.status}`);
            }

            const data = await resUser.json();
            if (data.success) {
                reload();
            }

        } catch (error) {
            console.error("Fetch error:", error);
        }
    };

    const handleAdminClick = async (id: number) => {
        if (isDetailPage) return;

        try {
            const res = await fetch(`${API_URL}/detail-admin-check/${id}`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                },
                body: JSON.stringify({ id }),
            });

            if (!res.ok) {
                throw new Error(`Error ${res.status}`);
            }

            const data = await res.json();
            if (data.success) {
                reload();
            }
        } catch (error) {
            console.error("Fetch error:", error);
        }
    };

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>, detailId: number) => {
        setLoadingSubmit(true);

        const files = e.target.files;
        if (!files || files.length === 0) return;

        const formData = new FormData();
        for (const file of files) {
            formData.append("files[]", file);
        }
        formData.append("detail_id", String(detailId));

        try {
            const res = await fetch(`${API_URL}/detail-upload-file`, {
                method: "POST",
                body: formData,
                credentials: "include",
            });

            if (!res.ok) throw new Error("Upload failed");

            const result = await res.json();
            console.log("Upload result:", result);

            reload();

        } catch (err) {
            console.error("Upload error:", err);
        }
        setLoadingSubmit(false);

    };

    const handleShare = async (id: string) => {
        try {
            const currentUrl = window.location.href;
            const shareUrl = currentUrl.replace("/edit/", "/detail/");

            await navigator.clipboard.writeText(shareUrl);

            Swal.fire({
                icon: "success",
                title: "Đã copy!",
                text: "Link chia sẻ đã được copy vào clipboard.",
                showConfirmButton: false,
                timer: 2000
            });
        } catch (err) {
            console.error("Copy error: ", err);

            Swal.fire({
                icon: "error",
                title: "Lỗi",
                text: "Không thể copy link!",
                confirmButtonText: "OK"
            });
        }
    };

    return (
        <div className="slide-bar">
            <div className="slide-bar__option">
                <div
                    className={`slide-bar__option__collapse slide-bar__option--item ${collapse ? "active" : ""
                        }`}
                    onClick={() => setCollapsed(!collapse)}
                >
                    <i className="fa-solid fa-angles-left"></i>
                    <p className="close">Đóng</p>
                    <p className="open hidden">Mở</p>
                </div>

                <div
                    className={`slide-bar__option__uncheck slide-bar__option--item ${filter === "notdone" ? "active" : ""}`}
                    onClick={() => setFilter(prev => prev === "notdone" ? null : "notdone")}
                >
                    <i className="fa-solid fa-xmark"></i>
                    <p>Chưa làm</p>
                </div>

                <div
                    className={`slide-bar__option__check slide-bar__option--item ${filter === "done" ? "active" : ""}`}
                    onClick={() => setFilter(prev => prev === "done" ? null : "done")}
                >
                    <i className="fa-solid fa-check"></i>
                    <p>Đã làm</p>
                </div>

                <div className="slide-bar__option__share" onClick={() => {
                    if (id) handleShare(id);
                }}>
                    <i className="fa-solid fa-share-nodes"></i>
                    <p>Chia sẻ</p>
                </div>
            </div>

            <div className={`slide-bar__list ${collapse ? "hidden" : ""}`}>
                {filteredDetails.length > 0 ? (
                    filteredDetails.map((detail, index) => (
                        <div className="slide-bar__list__item" key={detail.id} onClick={() => {
                            setScrollIndex(null);
                            setTimeout(() => setScrollIndex(index), 0);
                        }}
                        >
                            <div className="slide-bar__list__item__no">
                                <p>{String(index + 1).padStart(2, "0")}</p>
                            </div>

                            <div className="slide-bar__list__item__note">
                                <p className="whitespace-pre-line break-words">{detail.note || ""}</p>
                            </div>

                            <div className="slide-bar__list__item__group">
                                <div
                                    className={`user-check ${detail.user_check === 1 ? "active" : ""}`}
                                    onClick={() => handleUserClick(detail.id)}
                                >
                                    <i className="fa-solid fa-square-check fa-lg"></i>
                                </div>
                                <div
                                    className={`admin-check ${isDetailPage ? "disabled" : ""} ${detail.admin_check === 1 ? "active" : ""}`}
                                    onClick={() => !isDetailPage && handleAdminClick(detail.id)}
                                    style={{ cursor: isDetailPage ? "not-allowed" : "pointer" }}
                                >
                                    <i className="fa-solid fa-square-check fa-lg"></i>
                                </div>
                            </div>

                            <div className="slide-bar__list__item__file">
                                {!isDetailPage && (
                                    <div className="ic" onClick={() => document.getElementById(`file-input-${detail.id}`)?.click()}>
                                        <i className="fa-solid fa-plus"></i> Chọn file
                                        <input
                                            id={`file-input-${detail.id}`}
                                            type="file"
                                            className="hidden"
                                            multiple
                                            onChange={(e) => handleFileChange(e, detail.id)}
                                        />
                                    </div>
                                )}

                                {detail.files?.map((f: any) => (
                                    <a key={f.id} href={`${API_FILE}/${f.file}`} target="_blank" rel="noreferrer" className="name break-words">
                                        <p>File đính kèm: <span>{f.file.split("/").pop()}</span></p>
                                    </a>
                                ))}
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="text-center text-gray-500 mt-10">Không có chi tiết nào!</p>
                )}
            </div>

            {loadingSubmit && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]">
                    <div className="w-16 h-16 border-4 border-t-transparent border-white rounded-full animate-spin"></div>
                </div>
            )}
        </div>
    );
}
